export { default as useLifestyles } from './useLifestyles';
